import React, { useEffect } from 'react';
import {
  Dialog,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
} from '@mui/material';
import { useState } from 'react';
import {
  abbreviatedDays,
  formatDateMMDDYYYY,
  formatDateYYYYMMDD,
  validateIfNewItemAnyDateExist,
} from '../../../utilities/dates';
import {
  BODY_TEXT_1,
  BODY_TEXT_3,
  CALENDAR_ICON, CAPTION_TEXT_DARKORANGE_1, CLOSE_ICON, CONTAINED_BUTTON, HEADING_TEXT_1, HEADING_TEXT_4, Heading6500C
} from '../../../utilities/generatedClasses';
import CustomSelect from '../../../components/CustomSelect';
import GeneralAccess from '../../../dataAccess/GeneralAccess';
import { classNameTriskeleParser } from '../../../utilities/customStyles';
import { cleanData } from '../../../utilities/utils';
import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker  } from '@mui/x-date-pickers/DatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const parseDateString = (dateStr) => {
  if (!dateStr) return null;
  if (dayjs.isDayjs(dateStr)) return dateStr;
  // Try YYYY-MM-DD (API format) first, then MM-DD-YYYY (app format)
  const isoDate = dayjs(dateStr, "YYYY-MM-DD", true);
  if (isoDate.isValid()) return isoDate;
  const usDate = dayjs(dateStr, "MM-DD-YYYY", true);
  if (usDate.isValid()) return usDate;
  return null;
};

const DynamicDialog = (props) => {
  const [selectedItem, setItem] = useState(null);
  const [selectedMeasure, setSelectedMeasure] = useState(null);
  const [limit, setLimit] = useState({
    lowLimit1: 0,
    maxLimit1: 10000,
    lowLimit2: 0,
    maxLimit2: 10000
  });

  const [itemExistedByDate, setItemDateExisted] = useState(false);
  const [itemDatesOutOfSync, setItemDatesOutOfSync] = useState(false);
  const [isRecommendationInPast, setRecommendationInPast] = useState(false);
const [value, setValue] = React.useState(dayjs('2022-04-17'));
  const { onClose, open, data } = props;

  useEffect(() => {
    setItemDateExisted(false);
    setItemDatesOutOfSync(false);
    if(props && props.data && props.data.recommendation){
      let dayofWeekFreqcy = props.data.recommendation.DayOfWeekFreqcy;
      let _dayofWeekFreqcy = [];

      if(props.data.recommendation.DayofWeekFreqcy){
        props.data.recommendation.DayOfWeekFreqcy = props.data.recommendation.DayofWeekFreqcy
      }

      if(Array.isArray(dayofWeekFreqcy)){
        if( dayofWeekFreqcy.length > 0){
          const dayofWeekFreqcy0 = dayofWeekFreqcy[0].split(",");
          if (dayofWeekFreqcy0.length > 1) {
            _dayofWeekFreqcy = props.data.recommendation.DayOfWeekFreqcy[0].split(",");
          } else {
            _dayofWeekFreqcy = props.data.recommendation.DayOfWeekFreqcy
          }
        }
      } else {
        _dayofWeekFreqcy = props.data.recommendation.DayOfWeekFreqcy.split(",");
      }
      let item = {
        StartDate: props.data.recommendation.StartDate,
        EndDate: props.data.recommendation.EndDate,
        QtyDescrptr_Qty_UnitIdArray: props.data.recommendation.QtyDescrptr_Qty_UnitIdArray,
        DayOfWeekFreqcy: _dayofWeekFreqcy,
        Id: props.data.type == "EditOccurence" ? props.data.selectedRecommendation.RcmndtnOccurncId: props.data.recommendation.RcmndtnSeriesId,
        UnitArray: props.data.unitArrays,
        MeasureId: props.data.measure.MeasureId,
        Category: props.data.recommendation.category

      }

      var todayDate = new Date(window.clientDate).setHours(0, 0, 0, 0);
      var startDate = new Date(item.StartDate).setHours(0, 0, 0, 0)
 
      if(item.Id && startDate < todayDate ){
        setRecommendationInPast(true)
        // disableDates('StartDate', selectedItem);
        // updateData('StartDate', item.StartDate)
      } else {
        setRecommendationInPast(false)

      }

      if(startDate < todayDate){
        setTimeout(()=>{
          disablePastDates()

        }, 5000)

      }
      if(item.UnitArray && item.UnitArray[0].UnitId == "949"){
        let hours = item.QtyDescrptr_Qty_UnitIdArray[0] && item.QtyDescrptr_Qty_UnitIdArray[0].Qty ? item.QtyDescrptr_Qty_UnitIdArray[0].Qty: 0
        let minutes = item.QtyDescrptr_Qty_UnitIdArray[1] && item.QtyDescrptr_Qty_UnitIdArray[1].Qty ? item.QtyDescrptr_Qty_UnitIdArray[1].Qty: 0
        item.QtyDescrptr_Qty_UnitIdArray_HrMin = [
            {
                "QtyDescrptr": "Qty",
                "Qty": hours,
                "Max": 24,
                "UnitId": "5125"
            },
            {
              "QtyDescrptr": "Qty",
              "Qty": minutes,
              "Max": 60,
              "UnitId": "5126"
            }
        ]
      }

      if (
        item.QtyDescrptr_Qty_UnitIdArray &&
        item.QtyDescrptr_Qty_UnitIdArray[0] &&
        item.QtyDescrptr_Qty_UnitIdArray[0].QtyDescrptr === "MinutesQty"
      ) {
        const totalMinutes = Number(item.QtyDescrptr_Qty_UnitIdArray[0].Qty || 0);

        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        item.QtyDescrptr_Qty_UnitIdArray[0].UnitId = "949"
        item.QtyDescrptr_Qty_UnitIdArray_HrMin = [
          {
            QtyDescrptr: "Qty",
            Qty: hours,
            Max: 24,
            UnitId: "5125"
          },
          {
            QtyDescrptr: "Qty",
            Qty: minutes,
            Max: 60,
            UnitId: "5126"
          }
        ];
      }
      if(item.StartDate == '') item.StartDate = null;
      if(item.EndDate == '') item.EndDate = null;
      if (item.StartDate) {
        item.StartDate = formatDateYYYYMMDD(item.StartDate);
      }
      if (item.EndDate) {
        item.EndDate = formatDateYYYYMMDD(item.EndDate);
      }
      setItem(item);
      setSelectedMeasure(props.data.measure);
      let unitArray = cleanData(props.data.measure.UnitArray);
      if(unitArray){
          setLimit({
            lowLimit1: unitArray[0].LowQtyLmt,
            lowLimit2: unitArray[0].LowQtyLmt,
            maxLimit1: unitArray[0].HighQtyLmt,
            maxLimit2: unitArray[0].HighQtyLmt,
          });
      }
      if (props.data.type === 'AddSeries') {
        setTimeout(() => {
          const todayDate = getSelectedDate(new Date());
          let startDate = document.getElementById('startDate')
          let endDate = document.getElementById('endDate')
          if(startDate){
            startDate.setAttribute('min', todayDate);
          }
          if(endDate){
            endDate.setAttribute('min', todayDate);
          }
        }, 1000);
      }
    }

  }, [props]);

  const handleClose = () => {
    if (selectedItem.StartDate) {
      selectedItem.StartDate = formatDateMMDDYYYY(selectedItem.StartDate);
    }
    if (selectedItem.EndDate) {
      selectedItem.EndDate = formatDateMMDDYYYY(selectedItem.EndDate);
    }
    setItem(null);
    setSelectedMeasure(null);
    onClose(null);
  };

  const DOW_ABBR = ["SUN","MON","TUE","WED","THU","FRI","SAT"];

  function hasSelectedDaysInRange(startISO, endISO, selectedDows) {
    if (!startISO || !endISO || !Array.isArray(selectedDows) || selectedDows.length === 0) return true;

    const start = new Date(startISO);   // expects "YYYY-MM-DD"
    const end   = new Date(endISO);

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || start > end) return false;

    // collect the DOWs that actually appear at least once in the range
    const seen = new Set();
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      seen.add(DOW_ABBR[d.getDay()]);
      // early exit: once we've seen all required, we're done
      if (selectedDows.every(dow => seen.has(dow))) return true;
    }
    return selectedDows.every(dow => seen.has(dow));
  }

  const save = () => {
    if (data.type === 'AddSeries') {
      const addedRecommendations = props.RecommendationList;

      const existedRecommendations = addedRecommendations.filter(x => x.MeasureId === selectedItem.MeasureId);
      let isNewItemHaveAnyExistedDate = false;

      if (existedRecommendations.length > 0) {
        existedRecommendations.forEach((element) => {
          if (isNewItemHaveAnyExistedDate === false) {
            const isItemAnyDateExisted = validateIfNewItemAnyDateExist(element, selectedItem);
            if (!isItemAnyDateExisted) {
              isNewItemHaveAnyExistedDate = true;
            }
          }
        });

        if (isNewItemHaveAnyExistedDate) {
          setItemDateExisted(true);
          return;
        }
      }
    }

    const { StartDate, EndDate, DayOfWeekFreqcy } = selectedItem || {};
    // const daysOk = hasSelectedDaysInRange(StartDate, EndDate, DayOfWeekFreqcy);
    // if (!daysOk) {
    //   setItemDatesOutOfSync(true);
    //   return;
    // }

    if (selectedItem.StartDate) {
      selectedItem.StartDate = formatDateMMDDYYYY(selectedItem.StartDate);
    }
    if (selectedItem.EndDate) {
      selectedItem.EndDate = formatDateMMDDYYYY(selectedItem.EndDate);
    }

    if (data.type === 'AddSeries') {
      selectedItem.TempId = Math.round(Math.random() * Math.round(1000));
    }
     onClose(data.type, selectedItem);
  };


  const updateData = (property, value) => {
    let item = { ...selectedItem };
    item[property] = value;

    item = disableDates(property, item);

    setItem(item);
  };

  const convertQuantityByUnit = (currentItem, newUnitId, index) => {
    try {
      const currentQuantity = currentItem.QtyDescrptr_Qty_UnitIdArray[index].Qty;
    const oldUnitId = currentItem.QtyDescrptr_Qty_UnitIdArray[index].UnitId;
    currentItem.QtyDescrptr_Qty_UnitIdArray[index].UnitId = newUnitId;

    if (currentQuantity && currentQuantity !== 0 && oldUnitId && newUnitId) {
      return GeneralAccess.convertUnit(currentQuantity, oldUnitId, newUnitId).then((res) => {
        if (res && res.data.length) {
          currentItem.QtyDescrptr_Qty_UnitIdArray[index].Qty = res.data[0].CnvtdQty;
          setItem(currentItem);
        }
      });
    }
    setItem(currentItem);
    } catch (error) {
      
    }
    
  };

  const updateQtyUnit = (value, index, state) => {
    if (Number.isInteger(value) && value < 0) return;

    const item = { ...selectedItem };
    if (state === 'UnitId') {
      if(value == "949"){
            const totalMinutes = Number(item.QtyDescrptr_Qty_UnitIdArray[0].Qty || 0);
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;
            item.QtyDescrptr_Qty_UnitIdArray[0].UnitId = "949"
            item.QtyDescrptr_Qty_UnitIdArray_HrMin = [
              {
                QtyDescrptr: "Qty",
                Qty: hours,
                Max: 24,
                UnitId: "5125"
              },
              {
                QtyDescrptr: "Qty",
                Qty: minutes,
                Max: 60,
                UnitId: "5126"
              }
            ];

            setItem(item);
          } else {
           convertQuantityByUnit(item, value, index);

          }
    } else {
        const selectedUnitId = item.QtyDescrptr_Qty_UnitIdArray[index].UnitId;

        if (selectedUnitId) {
          const selectedUnitMinMax = item.UnitArray.find(x => x.UnitId == selectedUnitId);

          if (selectedUnitMinMax && parseInt(selectedUnitMinMax.LowQtyLmt) <= value && parseInt(selectedUnitMinMax.HighQtyLmt) >= value) {
            item.QtyDescrptr_Qty_UnitIdArray[index].Qty = value;
            setItem(item);
          }
        } else {
          item.QtyDescrptr_Qty_UnitIdArray[index].Qty = value;
          setItem(item);
        }
    
    }
  };

  const updateHrMinQtyUnit = (value, index, state) => {
    if (Number.isInteger(value) && value < 0) return;

    const item = { ...selectedItem };

  
    const selectedUnitId = item.QtyDescrptr_Qty_UnitIdArray[0].UnitId;  
    if(item.QtyDescrptr_Qty_UnitIdArray[0].Qty == 0){
      item.QtyDescrptr_Qty_UnitIdArray[0].Qty += value 

    }
    if (selectedUnitId) {
      if(state == "Hr" && value < 24 && value >= 0){
        item.QtyDescrptr_Qty_UnitIdArray_HrMin[index].Qty = value;
        setItem(item);
      } else if (state == "Min" && value < 60 && value >= 0){
        item.QtyDescrptr_Qty_UnitIdArray_HrMin[index].Qty = value;
        setItem(item);
      }
    } 

  }


  const disableDates = (property, item) => {
    if (property === 'StartDate' || property === 'EndDate') {
      const startDate = new Date(item.StartDate);
      const endDate = new Date(item.EndDate);

      let startDateEl = document.getElementById("startDate")
      let endDateEl = document.getElementById("endDate")
      if (property == 'StartDate') {
        if (endDate.getTime() < startDate.getTime()) {
          item.EndDate = '';
          if(endDateEl){
            endDateEl.value = null;
          }
        }
        if(endDateEl){
          endDateEl.setAttribute('min', getSelectedDate(startDate));
        }
      } else {
        if (endDate.getTime() < startDate.getTime()) {
          item.StartDate = '';
          if(startDateEl){
            startDateEl.value = null;
          }
        }
        if(startDateEl){
          startDateEl.setAttribute('max', getSelectedDate(endDate));
        }
      }
    }

    return item;
  };


    const onStartChange = (newStart) => {
    const nextStart = newStart && newStart.isValid() ? newStart : null;
    const formatted = nextStart ? nextStart.format("MM-DD-YYYY") : "";

    // If start > end → clear end
    if (nextStart && selectedItem.EndDate && nextStart.isAfter(parseDateString(selectedItem.EndDate), "day")) {
      updateData("StartDate", formatted);
      setItem((prev) => ({ ...prev, StartDate: formatted, EndDate: null }));
      return;
    }

    updateData("StartDate", formatted);
  };

  const onEndChange = (newEnd) => {
    const nextEnd = newEnd && newEnd.isValid() ? newEnd : null;
    const formatted = nextEnd ? nextEnd.format("MM-DD-YYYY") : "";

    // If end < start → clear start
    if (nextEnd && selectedItem.StartDate && nextEnd.isBefore(parseDateString(selectedItem.StartDate), "day")) {
      updateData("EndDate", formatted);
      setItem((prev) => ({ ...prev, StartDate: null, EndDate: formatted }));
      return;
    }

    updateData("EndDate", formatted);
  };

  const disablePastDates = () => {
      let endDateEl = document.getElementById("endDate")

      var todayDate = new Date()
      if(endDateEl){
        endDateEl.setAttribute('min', getSelectedDate(todayDate));
      }
 
  };

  const updateSelectedDays = (day, checked) => {
    const item = { ...selectedItem };
    const selectedDay = item.DayOfWeekFreqcy.filter(x => x === day);
    let updatedSelectedDays = item.DayOfWeekFreqcy;
    if (selectedDay.length > 0) {
      updatedSelectedDays = updatedSelectedDays.filter(x => x !== day);
    } else {
      updatedSelectedDays.push(day);
    }
    item.DayOfWeekFreqcy = abbreviatedDays.filter(abbreviatedDay => updatedSelectedDays.includes(abbreviatedDay));

    setItem(item);
  };

  const getSelectedDate = (date) => {
    let month = date.getMonth() + 1;
    let day = date.getDate();
    const year = date.getFullYear();
    if (month < 10) month = `0${month.toString()}`;
    if (day < 10) day = `0${day.toString()}`;

    return `${year}-${month}-${day}`;
  };
  return (
    <>
      {data && selectedItem && (
        <Dialog aria-labelledby="title" id="dynamic-dialog" open={open}>
        <div className="dynamic-dialog-container">
          <div className="row-flex space-between">
            <div className="row-flex align-center">
              <div
                className={`MeasureIconDialog ${classNameTriskeleParser(`${selectedMeasure.VisualNameOne}`, `${selectedMeasure.VisualTypeOne}`, 'Icon')}`}
                style={{
                  height: '60px', width: '60px', margin: '0px 10px', WebkitMaskImage: selectedMeasure.MeasureIcon
                }}
               />
              <div className={Heading6500C}>{selectedMeasure.MeasureName}</div>
            </div>

            <div
              className={CLOSE_ICON}
              onClick={handleClose}
              style={{ height: '20px', width: '20px', margin: '0px 10px' }}
              aria-hidden="true"
             />
          </div>
          <hr
            style={{
              marginLeft: '1rem',
              marginRight: '1rem',
              backgroundColor: '#8C9093',
            }}
          />
          <div className="row vertical-center-row" style={{ margin: '2rem 1rem' }}>

            {selectedMeasure && selectedMeasure.RcmndtnType === 'Single' && selectedItem.QtyDescrptr_Qty_UnitIdArray[0].UnitId != "949" && (
            <div className="col-md-12 row-flex space-between column-gap-20 mb-10" style={{ padding: 0 }}>
              <div className="dialog-field">
                <label className={BODY_TEXT_1}>Quantity</label>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                    inputprops: { min: limit.lowLimit1, max: limit.maxLimit1 }
                  }}
                  value={selectedItem.QtyDescrptr_Qty_UnitIdArray[0].Qty}
                  onChange={e => updateQtyUnit(e.target.value, 0, 'Qty')}
                  variant="standard"
                  placeholder="-"
                  type="number"
                />
              </div>
              <div className="dialog-field">
                <label className={BODY_TEXT_1}>Unit</label>

                <CustomSelect
                  title=""
                  value={selectedItem.QtyDescrptr_Qty_UnitIdArray[0].UnitId}
                  state="UnitId"
                  func={updateQtyUnit}
                  options={selectedItem.UnitArray}
                  type="unitConversion"
                  index="0"
                  optionValue="UnitId"
                  optionTitle="UnitAbrvName" />
              </div>
            </div>
            )}

            {selectedMeasure && selectedItem.QtyDescrptr_Qty_UnitIdArray[0].UnitId == "949" && selectedItem.QtyDescrptr_Qty_UnitIdArray_HrMin && (
            <div className="col-md-12 row-flex space-between column-gap-20 mb-10">
              <div className="dialog-field">
                <label className={BODY_TEXT_1}>Hours</label>

                <TextField
                  InputLabelProps={{
                    shrink: true,
                    inputprops: { min: 0, max: 24 }
                  }}
                  value={selectedItem.QtyDescrptr_Qty_UnitIdArray_HrMin[0].Qty}
                  onChange={e => updateHrMinQtyUnit(e.target.value, 0, 'Hr')}
                  variant="standard"
                  placeholder="-"
                  type="number"
                />

              </div>
              <div className="dialog-field">
                <label className={BODY_TEXT_1}>Minutes</label>

                <TextField
                  InputLabelProps={{
                    shrink: true,
                    inputprops: { min: 0, max: 60 }
                  }}
                  value={selectedItem.QtyDescrptr_Qty_UnitIdArray_HrMin[1].Qty}
                  onChange={e => updateHrMinQtyUnit(e.target.value, 1, 'Min')}
                  variant="standard"
                  placeholder="-"
                  type="number"
                />

              </div>

              <div className="dialog-field">
                <label className={BODY_TEXT_1}>Unit</label>

                <CustomSelect
                  value={selectedItem.QtyDescrptr_Qty_UnitIdArray[0].UnitId}
                  state="UnitId"
                  type="unitConversion"
                  func={updateQtyUnit}
                  index="0"
                  options={selectedItem.UnitArray}
                  optionValue="UnitId"
                  optionTitle="UnitAbrvName" />
              </div>
            </div>
            )}

            {selectedMeasure && ((selectedMeasure.RcmndtnType === 'Low-High' && selectedMeasure.MeasureCmpntCount === '0')) && (
            <div className="col-md-12 row-flex space-between column-gap-20 mb-10">
              <div className="dialog-field">
                <label className={BODY_TEXT_1}>Low Quantity</label>

                <TextField
                  InputLabelProps={{
                    shrink: true,
                    inputprops: { min: limit.lowLimit1, max: limit.maxLimit1 }
                  }}
                  value={selectedItem.QtyDescrptr_Qty_UnitIdArray[0].Qty}
                  onChange={e => updateQtyUnit(e.target.value, 0, 'Qty')}
                  variant="standard"
                  placeholder="-"
                  type="number"
                />

              </div>
              <div className="dialog-field">
                <label className={BODY_TEXT_1}>High Quantity</label>

                <TextField
                  InputLabelProps={{
                    shrink: true,
                    inputprops: { min: limit.lowLimit1, max: limit.maxLimit1 }
                  }}
                  value={selectedItem.QtyDescrptr_Qty_UnitIdArray[1].Qty}
                  onChange={e => updateQtyUnit(e.target.value, 1, 'Qty')}
                  variant="standard"
                  placeholder="-"
                  type="number"
                />

              </div>
              <div className="dialog-field">
                <label className={BODY_TEXT_1}>Unit</label>

                <CustomSelect
                  value={selectedItem.QtyDescrptr_Qty_UnitIdArray[0].UnitId}
                  state="UnitId"
                  type="unitConversion"
                  func={updateQtyUnit}
                  index="0"
                  options={selectedItem.UnitArray}
                  optionValue="UnitId"
                  optionTitle="UnitAbrvName" />
              </div>
            </div>
            )}
            {selectedMeasure && selectedMeasure.RcmndtnType == 'Low-High' && selectedMeasure.MeasureCmpntCount == '2' && (
            <>
              <div className={HEADING_TEXT_1} style={{ marginLeft: '20px', marginBottom: '8px' }}>{selectedItem.QtyDescrptr_Qty_UnitIdArray[0].QtyDescrptr.split(/(?=[A-Z])/)[0]}</div>
              <div className="col-md-12 row-flex space-between column-gap-20 mb-10">
                <div className="dialog-field">
                <label className={BODY_TEXT_1}>Low Quantity</label>

                  <TextField
                    InputLabelProps={{
                      shrink: true,
                      inputprops: { min: limit.lowLimit1, max: limit.maxLimit1 }
                    }}
                    value={selectedItem.QtyDescrptr_Qty_UnitIdArray[0].Qty}
                    onChange={e => updateQtyUnit(e.target.value, 0, 'SystolicLowQty')}
                    variant="standard"
                    placeholder="-"
                    type="number"
                />
                </div>
                <div className="dialog-field">
                <label className={BODY_TEXT_1}>High Quantity</label>

                  <TextField
                    InputLabelProps={{
                      shrink: true,
                      inputprops: { min: limit.lowLimit1, max: limit.maxLimit1 }
                    }}
                    value={selectedItem.QtyDescrptr_Qty_UnitIdArray[1].Qty}
                    onChange={e => updateQtyUnit(e.target.value, 1, 'SystolicHighQty')}
                    variant="standard"
                    placeholder="-"
                    type="number"
                />

                </div>
                <div className="dialog-field">
                <label className={BODY_TEXT_1}>Unit</label>
                  <CustomSelect
                    title=""
                    value={selectedItem.QtyDescrptr_Qty_UnitIdArray[0].UnitId}
                    state="SystolicUnitId"
                    func={updateQtyUnit}
                    index="0"
                    type="unitConversion"
                    options={selectedItem.UnitArray}
                    optionValue="UnitId"
                    optionTitle="UnitAbrvName" />
                </div>
              </div>
              <div className={HEADING_TEXT_1} style={{ marginLeft: '20px', marginBottom: '8px', marginTop: '12px' }}>{selectedItem.QtyDescrptr_Qty_UnitIdArray[2].QtyDescrptr.split(/(?=[A-Z])/)[0]}</div>

              <div className="col-md-12 row-flex space-between column-gap-20 mb-10">
                <div className="dialog-field">
                <label className={BODY_TEXT_1}>Low Quantity</label>
                  <TextField
                    InputLabelProps={{
                      shrink: true,
                      inputprops: { min: limit.lowLimit2, max: limit.maxLimit2 }
                    }}
                    value={selectedItem.QtyDescrptr_Qty_UnitIdArray[2].Qty}
                    onChange={e => updateQtyUnit(e.target.value, 2, 'DiastolicLowQty')}
                    variant="standard"
                    placeholder="-"
                    type="number"
                />

                </div>
                <div className="dialog-field">
                <label className={BODY_TEXT_1}>High Quantity</label>

                  <TextField
                    InputLabelProps={{
                      shrink: true,
                      inputprops: { min: limit.lowLimit2, max: limit.maxLimit2 }
                    }}
                    value={selectedItem.QtyDescrptr_Qty_UnitIdArray[3].Qty}
                    onChange={e => updateQtyUnit(e.target.value, 3, 'DiastolicHighQty')}
                    variant="standard"
                    placeholder="-"
                    type="number"
                />

                </div>
                <div className="dialog-field">
                <label className={BODY_TEXT_1}>Unit</label>

                  <CustomSelect
                    value={selectedItem.QtyDescrptr_Qty_UnitIdArray[2].UnitId}
                    state="DiastolicUnitId"
                    func={updateQtyUnit}
                    index="2"
                    type="unitConversion"
                    options={selectedItem.UnitArray}
                    optionValue="UnitId"
                    optionTitle="UnitAbrvName" />
                </div>
              </div>
            </>
            )}

            {(data.type === 'EditSeries'
              || data.type === 'AddSeries')
              && selectedItem && (
                <>
                  <div className={`col-md-12 ${HEADING_TEXT_4} mt-30 mb-30`}>
                    Repeat
                  </div>
                  <div
                    className="col-md-12 "
                    id="checkboxes"
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    {abbreviatedDays.map(day => (
                      <FormControlLabel
                        control={<Checkbox />}
                        label={day}
                        onChange={e => updateSelectedDays(day, e.checked)}
                        checked={
                          selectedItem.DayOfWeekFreqcy
                          && selectedItem.DayOfWeekFreqcy.includes(day)
                        }
                        className={BODY_TEXT_3}
                      />
                    ))}
                  </div>
                  <div className="col-md-12 row-flex space-between mt-30" style={{ paddingBottom: '30px', gap: "20px"}}>
                    <div className="dialog-field">
                      <label className={BODY_TEXT_1}>Start Date</label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker', 'DatePicker']}>
                          
                              <DesktopDatePicker
                          className="date-picker"
                          value={parseDateString(selectedItem.StartDate)}
                          minDate={dayjs()}
                          maxDate={parseDateString(selectedItem.EndDate) || undefined}
                          onChange={onStartChange}
                        />
                        
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                    <div className="dialog-field">
                        <label className={BODY_TEXT_1}>End Date</label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker', 'DatePicker']}>
                        
                            <DesktopDatePicker
                          className="date-picker"
                          value={parseDateString(selectedItem.EndDate)}
                          minDate={parseDateString(selectedItem.StartDate) || dayjs()}
                          onChange={onEndChange}
                        />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>

                  </div>

                  {itemExistedByDate
                  && (
                  <div className={CAPTION_TEXT_DARKORANGE_1} style={{ margin: '10px 20px' }}>
                    The measure has already been set for this day
                  </div>
                  )
                  }

                  {
                  itemDatesOutOfSync
                   && (
                  <div className={CAPTION_TEXT_DARKORANGE_1} style={{ margin: '10px 20px' }}>
                    Selected days of week do not occur within the chosen date range.
                  </div>
                  )
                  }

                </>
            )}
          </div>
        </div>
          <div className="dynamic-d-btn btnContained">
        <Button
          variant="contained"
          className={CONTAINED_BUTTON}
          onClick={save}
          disabled={selectedItem && (selectedItem.EndDate === '' || selectedItem.StartDate === '' || !selectedItem.StartDate || !selectedItem.EndDate
                    || (selectedItem.DayOfWeekFreqcy && selectedItem.DayOfWeekFreqcy.length === 0) || selectedItem.QtyDescrptr_Qty_UnitIdArray.find(x => x.Qty === 0))
          }
          >
          Confirm
        </Button>
      </div>
    </Dialog>
      )}
  </>
    
  );
};

export default DynamicDialog;